import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import "./Thankyou.scss";
import CloseBtn from "./components/CloseBtn";

const Thankyou: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-[315px] p-6 bg-white">
      <CloseBtn />
      <div>
        <p className="popup-title">{t("Thank you")}</p>
      </div>
      <div className="thank-you-text-wrapper thank-you-text">
        <Trans i18nKey="Thank you text" components={{ 1: <br /> }} />
      </div>
    </div>
  );
};

export default Thankyou;
